import { render } from "./RiskWatch.vue?vue&type=template&id=05fc5cc9&scoped=true"
import script from "./RiskWatch.vue?vue&type=script&lang=js"
export * from "./RiskWatch.vue?vue&type=script&lang=js"

import "./RiskWatch.vue?vue&type=style&index=0&id=05fc5cc9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fc5cc9"]])

export default __exports__